import axios from "axios";

export default function () {
	const storageKey = `oidc.user:${process.env.VUE_APP_authorityUrl}:HelpdeskClient`;
	const userString = window.localStorage.getItem(storageKey);
	//@ts-ignore
	const user = JSON.parse(userString);
	const client = axios.create({
		baseURL: process.env.VUE_APP_SERVER_URL,
		headers: {
			Authorization: "Bearer " + user.access_token,
		},
	});

	client.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				// Der Server lehnt den gespeicherten Token ab, obwohl er dem oidc-client
				// clientseitig noch gültig erscheint (z.B. ein Token, der noch vom alten
				// Identityserver signiert wurde). Token löschen und neu anmelden lassen,
				// statt den Benutzer mit einem kaputten Token hängen zu lassen.
				console.log("Server rejected the stored token (401) - clearing it and reloading.");
				window.localStorage.removeItem(storageKey);
				window.location.reload();
			}
			return Promise.reject(error);
		}
	);

	return client;
}
